import React from "react";
import { connect } from "react-redux";
import { ProvinceAction } from "../../actions";
import { Field, reduxForm, SubmissionError } from "redux-form";
import Button from "../../components/button";
import FloatLabelInput from "../../components/floatLableInput";
import ExpandHeightTextarea from "../../components/expandHeightTextarea";
import DatePicker from "../../components/datepicker";
import SelectBox from "../../components/selectbox";
import AutoComplete from "../../components/autocomplete";
import formPicker from "../../selectors/formPicker";
import { ProjectType } from "../../constants/projectType";
import SelectCurrency from "../selectCurrency";
import defaultCountryCode from "../../constants/defaultCountryCode";
import {isEqual} from "lodash";

class Form extends React.Component {

  constructor(props) {
    super(props);
    this.state={
      showLocation:false,
    }
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.init.data, this.props.init.data)){
      this.showLocation();
    }
  }
  componentDidMount() {
    this.showLocation()
  }

  UNSAFE_componentWillMount() {
    if (this.props.localization.provinces.length <= 0) {
      this.props.getProvince();
    }
  }
  submit(values) {
    let errors = {};
    if (!values.name) {
      errors.name = "نام پروژه اجباری است";
    }
    if (!values.type) {
      errors.type = "نوع پروژه اجباری است";
    }
    if (this.state.showLocation && !values.state_id) {
      errors.state_id = "استان اجباری است";
    }
    if (this.state.showLocation && !values.city_id) {
      errors.city_id = "شهر اجباری است";
    }
    if (!values.currency) {
      errors.currency = "واحد ارزی اجباری است";
    }
    if (Object.keys(errors).length <= 0) {
      this.props.onSubmit({ ...values, currency: values.currency.id || values.currency.key });
    } else {
      throw new SubmissionError(errors);
    }
  }
  normalize(items) {
    let result = [];
    items.forEach(item => {
      result.push({
        key: item.id,
        value: item.name
      });
    });
    return result;
  }
  cityStatus() {
    const { form_data } = this.props;
    return !(form_data && form_data.values && form_data.values.state_id);
  }
  showLocation() {
    const { init } = this.props;
    let show = (
      init.data &&
      init.data.data &&
      init.data.data.user &&
      init.data.data.user.country_code &&
      init.data.data.user.country_code.id === defaultCountryCode.id
    );
    let show1 = init.data &&
        init.data &&
        init.data.user &&
        init.data.user.country_code &&
        init.data.user.country_code.id === defaultCountryCode.id;
    this.setState({showLocation: show || show1})
  }
  render() {
    const {
      handleSubmit,
      localization,
      submitButtonText,
      loading,
      form_data
    } = this.props;
    if (form_data) {
      if (form_data.values) {
        if (!form_data.values.state_id) {
          this.props.cleanCities();
        }
      }
    }
    const provinces = this.normalize(localization.provinces);
    const cities = this.normalize(localization.province_cities);
    return (
      <form onSubmit={handleSubmit(this.submit.bind(this))}>
        <input type="hidden" value="something" />
        <Field
          name="name"
          component={FloatLabelInput}
          type="text"
          label="نام پروژه"
          disabled={loading}
        />
        <div className="field" style={{ width: "90%" }}>
          <i className="icon mapsa-outline-layers side-icon" />
          <Field
            name="type"
            component={SelectBox}
            label="انتخاب نوع پروژه"
            disabled={loading}
            options={ProjectType}
          />
          <div className="column-2">
            <Field
              onChange={data => {
                this.props.change("currency", data);
              }}
              label="انتخاب واحد ارزی"
              name="currency"
              component={SelectCurrency}
            />
          </div>
        </div>
        {this.state.showLocation && (
          <div className="field">
            <i className="icon mapsa-place side-icon" />
            <div className="column-1">
              <Field
                name="state_id"
                component={AutoComplete}
                placeholder="استان"
                listItems={provinces}
                listLoading={localization.loading}
                type="text"
                disabled={loading}
                onChange={data => {
                  this.props.change("city_id", null);
                  if (data !== null) {
                    this.props.getCity({
                      id: data.key,
                      name: data.value
                    });
                  } else {
                  }
                }}
              />
            </div>
            <div className="column-2">
              <Field
                name="city_id"
                component={AutoComplete}
                placeholder="شهر"
                listItems={cities}
                listLoading={localization.loading}
                type="text"
                disabled={this.cityStatus()}
              />
            </div>
          </div>
        )}
        <div className="field">
          <div>
            <div className="field-label">شروع پروژه:</div>
            <div className="inner-field">
              <i className="icon mapsa-calendar side-icon" />
              <Field
                name="start_date"
                component={DatePicker}
                placeholder="انتخاب تاریخ"
              />
            </div>
          </div>
        </div>
        <div className="field">
          <i className="icon mapsa-description side-icon" />
          <Field
            disable={loading}
            name="description"
            component={ExpandHeightTextarea}
            placeholder="توضیحات"
          />
        </div>

        <div className="buttons">
          <Button type="submit" btn="primary" loading={loading}>
            {submitButtonText ? submitButtonText : "ایجاد پروژه"}
          </Button>
          <Button
            btn="secondary"
            type="reset"
            disabled={loading}
            onClick={
              this.props.onCancel ? () => this.props.onCancel() : () => false
            }
          >
            انصراف
          </Button>
        </div>
      </form>
    );
  }
}

const validate = values => {
  const errors = {};
  if (values.name && values.name.length > 50) {
    errors.name = "نام پروژه نباید بیشتر از ۵۰ کاراکتر باشد";
  }
  if (values.description && values.description.length > 200) {
    errors.description = "توضیحات پروژه نباید بیشتر از ۲۰۰ کاراکتر باشد.";
  }

  return errors;
};

Form = reduxForm({
  form: "add_project",
  validate
})(Form);

const mapStateToProps = store => {
  return {
    form_data: formPicker(store, "add_project"),
    localization: store.Province,
    loading: store.Project.loading,
    init: store.Init
  };
};
const mapDispatchToProps = dispatch => {
  return {
    getProvince: () => {
      dispatch(ProvinceAction.get());
    },
    getCity: data => {
      dispatch(ProvinceAction.getCity(data));
    },
    cleanCities: () => {
      dispatch(ProvinceAction.cleanCities());
    }
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form);
